<app-dispute-details
    [dispute]="dispute$ | async"
    [disputeLoading]="disputeLoading$ | async"
    (cancel)="onCancel()">
</app-dispute-details>
